import React from 'react';
import { View, Text, StyleSheet, } from 'react-native';
import Colors from '../constants/Colors';
import CS from '../constants/Styles';
import { BackgroundGradient, SafeAreaView } from '../components';
import { MaterialCommunityIcons } from '@expo/vector-icons';

const NotFoundScreen = ({ navigation }) => {
  
  return (
    <SafeAreaView style={CS.safe}>
      <View style={CS.container}>
        <BackgroundGradient />
        <View style={styles.view}>
          <MaterialCommunityIcons name="link-variant-off" size={64} color={Colors.yellow} style={styles.icon} />
          <Text style={[CS.mediumText, CS.boldText, CS.yellowText]}>Not Found</Text>
        </View>
      </View>
    </SafeAreaView>
  );

}

const styles = StyleSheet.create({
  icon: {
    marginBottom: 10
  },
  view: {
    alignItems: 'center'
  }
});

export default NotFoundScreen;